import type React from "react"

import type { CourseDetail } from "@/lib/types/course/detail"
import { Formatter } from "@/lib/helpers/formatter"
import { COURSE_STATUS } from "@/lib/constants/course"

export const Price = {
	onPost: (course: CourseDetail): React.JSX.Element => {
		if (course.status.status === COURSE_STATUS.CONTINUE_LEARNING) {
			return <span className="font-bold text-teal-500 text-xl">Đã mua</span>
		}
		if (course.status.status === COURSE_STATUS.PURCHASING) {
			return <span className="font-bold text-teal-500 text-xl">Đợi thanh toán</span>
		}
		if (course.status.status === COURSE_STATUS.GIFTED) {
			return <span className="font-bold text-purple-500 text-xl">Được tặng kèm</span>
		}
		let appendText = null;
		if (course.status.status === COURSE_STATUS.WAITING_FOR_PAYMENT) {
			appendText = <span className="text-gray-500 text-sm">Đã thêm vào giỏ hàng</span>
		}

		return (
			<>
			<div className="mb-2 font-bold text-xl">
				<span className="text-teal-500">
					{Formatter.formatMoney(course.price_discount)}
				</span>
				{course.price_discount !== course.price && (
					<>
						<span className="ml-2 text-gray-500 text-sm line-through">
							{Formatter.formatMoney(course.price)}
						</span>
						{course.discount > 0 && (
							<span className="ml-2 inline-block rounded-full bg-red-100 px-2 py-1 text-red-500 text-sm">
								-{course.discount}% OFF
							</span>
						)}
					</>
				)}
			</div>
			{appendText}
			</>
		)
	},
	
	onList: (data: CourseDetail): React.JSX.Element => {
		if (data.status.status === COURSE_STATUS.CONTINUE_LEARNING) {
			return <span className="font-bold text-teal-500 text-xl">Đã mua</span>
		}
		if (data.status.status === COURSE_STATUS.GIFTED) {
			return <span className="font-bold text-purple-500 text-xl">Được tặng kèm</span>
		}
		return (
			<>
				<span className="mr-2 font-bold text-base text-primary sm:text-lg">
					{Formatter.formatMoney(data.price_discount)}
				</span>
				{data.price_discount !== data.price && (
					<>
						<span className="text-gray-500 text-xs line-through sm:text-sm">
							{Formatter.formatMoney(data.price)}
						</span>
						{data.discount > 0 && (
							<span className="ml-2 rounded-full bg-red-100 px-2 py-1 font-medium text-red-700 text-xs">
								-{data.discount}% OFF
							</span>
						)}
					</>
				)}
			</>
		)
	},
	
	discount: (data: CourseDetail): React.JSX.Element => {
		if (!data || !data.status) return <></>
		if (data.status.status === COURSE_STATUS.CONTINUE_LEARNING || data.status.status === COURSE_STATUS.PURCHASING || data.status.status === COURSE_STATUS.GIFTED) return <></>
		if (data.price_discount === data.price) return <></>
		if (data.discount > 0) {
			return (
				<span className="rounded-full bg-red-100 px-2 py-1 font-medium text-red-700 text-xs">
					-{data.discount}% OFF
				</span>
			)
		}
		return <></>
	},
	
	discountCard: (data: CourseDetail): React.JSX.Element => {
		if (!data || !data.status) return <></>
		if (data.status.status === COURSE_STATUS.CONTINUE_LEARNING || data.status.status === COURSE_STATUS.PURCHASING || data.status.status === COURSE_STATUS.GIFTED) return <></>
		if (data.price_discount === data.price) return <></>
		if (data.discount > 0) {
			return (
				<span className="absolute top-0 left-0 rounded-br-lg px-2 py-1 text-sm text-white">
					<span className="rounded-full bg-red-100 px-2 py-1 font-medium text-red-700 text-xs">
						-{data.discount}% OFF
					</span>
				</span>
			)
		}
		return <></>
	},
	
	getButtonText: (status: number, allStatuses: any): string => {
		const key = `${status}.status` as unknown as keyof any
		const buttonText = allStatuses[key]
		return typeof buttonText === "string" ? buttonText : "Đăng ký"
	},
	
	getContentPrice: (data: CourseDetail): string => {
		let contentPrice: string
		if (!data || !data.status) return "Blog"
		switch (true) {
			case data.status.status === COURSE_STATUS.CONTINUE_LEARNING:
				contentPrice = "Đã mua"
				break
			case data.status.status === COURSE_STATUS.PURCHASING:
				contentPrice = "Đang mua"
				break
			case data.status.status === COURSE_STATUS.GIFTED:
				contentPrice = "Được tặng kèm"
				break
			case data.price > 0:
				contentPrice = Formatter.formatMoney(data.price_discount)
				break
			case data.price === 0:
				contentPrice = "Miễn phí"
				break
			default:
				contentPrice = "Blog"
		}
		return contentPrice
	}
}
